import React, { Component } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Table, Button, ButtonGroup, ButtonToolbar } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import DatePicker from "react-datepicker";

import "react-circular-progressbar/dist/styles.css";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import PropTypes from "prop-types";
import selectors from "./selectors";
import actions from "../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import graph from "../../../common/utils/graph";
import exportTo from "../../../common/utils/exportTo";

const line = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: "New Users",
      fill: false,
      lineTension: 0.1,
      backgroundColor: "rgba(75,192,192,0.4)",
      borderColor: "rgba(75,192,192,1)",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [65, 59, 80, 81, 56, 55, 40],
    },
  ],
};

const noLabelOptions = {
  legend: {
    display: false,
  },
  tooltips: {
    enabled: false,
  },
  responsive: true,
  maintainAspectRatio: true,
};

class Report extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activity_users_range: 2,
      app_downloads_range: 2,
      app_shares_range: 2,
      revenue_range: 2,
      active_users: [],
      new_users: [],
      active_counts: 0,
      all_counts: 0,
      active_new_graph: null,
      options: {
        tooltips: {
          enabled: false,
        },
        responsive: true,
        maintainAspectRatio: true,
      },
      activity_users_date: moment().toDate(),
      revenue_date: moment().toDate(),
      revenues: [],
      revenues_graph: null,

      numeric_report_date: moment().toDate(),
      dau: 0,
      ds_per_users: 0,
      mau: 0,
      stickiness: 0,
    };

    this.onHandleRange = this.onHandleRange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  componentDidMount() {
    const {
      getReportData,
      getActivityUsers,
      getRevenueGraph,
      getNumericReport,
    } = this.props;
    const {
      activity_users_date,
      revenue_date,
      activity_users_range,
      app_downloads_range,
      app_shares_range,
      revenue_range,
      numeric_report_date,
    } = this.state;
    getReportData({ app_downloads_range, app_shares_range })
      .then(({ result: { data } }) => {
        const { active_counts, all_counts } = data;
        this.setState({ active_counts, all_counts });
      })
      .catch((error) => {
        toast.error("Failed to get report data");
      });

    getActivityUsers({ activity_users_range: 3, activity_users_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { active_users, new_users } = data;
          const active_new_graph = graph.convertTwoGraph(
            active_users,
            new_users,
            "Active Users",
            "New Users",
            activity_users_range
          );
          this.setState({ active_users, new_users, active_new_graph });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getRevenueGraph({ revenue_range: 3, revenue_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { revenues } = data;
          const revenues_graph = graph.convertDataToLineGraph(
            revenues,
            revenue_range,
            "Revenue Data",
            revenue_date
          );
          this.setState({ revenues, revenues_graph });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });

    getNumericReport({ numeric_report_date })
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          const { dau, ds_per_users, mau, stickiness } = data;
          this.setState({ dau, ds_per_users, mau, stickiness });
        }
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  handleChangeDate(type, date) {
    const { getActivityUsers, getRevenueGraph, getNumericReport } = this.props;
    const { activity_users_range, revenue_range, numeric_report_date } =
      this.state;

    if (type === "activity_users") {
      getActivityUsers({ activity_users_range, activity_users_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            const { active_users, new_users } = data;
            const active_new_graph = graph.convertTwoGraph(
              active_users,
              new_users,
              "Active Users",
              "New Users",
              activity_users_range,
              date
            );
            this.setState({
              active_users,
              new_users,
              active_new_graph,
              activity_users_date: date,
            });
          }
        })
        .catch((error) => {
          toast.error("Internal Server Error");
        });
    }

    if (type === "revenue") {
      getRevenueGraph({ revenue_range, revenue_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            const { revenues } = data;
            const revenues_graph = graph.convertDataToLineGraph(
              revenues,
              revenue_range,
              "Revenue Data",
              date
            );
            this.setState({
              revenues,
              revenues_graph,
              revenue_range,
              revenue_date: date,
            });
          }
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    }

    if (type === "numeric_report_date") {
      getNumericReport({ numeric_report_date: date })
        .then(({ result: { data } }) => {
          if (data.result === "success") {
            this.setState({ numeric_report_date: date });
          }
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    }
  }

  handleExport(type) {
    const {
      active_new_graph,
      activity_users_date,
      activity_users_range,
      all_counts,
      active_counts,
      dau,
      mau,
      ds_per_users,
      stickiness,
    } = this.state;
    if (type === 1) {
      exportTo.exportActivityUsers(
        active_new_graph,
        activity_users_range,
        activity_users_date
      );
    } else if (type === 2) {
      exportTo.exportActivityUserRate(all_counts, active_counts);
    } else if (type === 4) {
      //export numeric report
      const numeric_report = [
        {
          "Daily Active Users": dau,
          "Monthly Active Users": mau,
          "Daily Sessions per DAU": ds_per_users,
          Stickiness: stickiness,
        },
      ];
      exportTo.exportNumericReport(numeric_report);
    }
  }

  onHandleRange(type, radio) {
    const { activity_users_date, revenue_date } = this.state;
    const { getActivityUsers, getRevenueGraph } = this.props;

    switch (type) {
      case 1: //activity users
        getActivityUsers({ activity_users_range: radio, activity_users_date })
          .then(({ result: { data } }) => {
            if (data.result === "success") {
              const { active_users, new_users } = data;
              const active_new_graph = graph.convertTwoGraph(
                active_users,
                new_users,
                "Active Users",
                "New Users",
                radio,
                activity_users_date
              );
              this.setState({
                active_users,
                new_users,
                active_new_graph,
                activity_users_range: radio,
              });
            }
          })
          .catch((error) => {
            toast.error("Internal Server Error");
          });
        break;
      case 2: //app downloads
        this.setState({
          app_downloads_range: radio,
        });
        break;
      case 3: //app shares
        this.setState({
          app_shares_range: radio,
        });
        break;
      case 4: //revenue
        getRevenueGraph({ revenue_range: radio, revenue_date })
          .then(({ result: { data } }) => {
            if (data.result === "success") {
              const { revenues } = data;
              const revenues_graph = graph.convertDataToLineGraph(
                revenues,
                radio,
                "Revenue Data",
                revenue_date
              );
              this.setState({ revenues, revenues_graph, revenue_range: radio });
            }
          })
          .catch((error) => {
            toast.error("Internal Server Error");
          });
        break;
    }
  }

  renderActivityUsers() {
    const {
      active_new_graph,
      activity_users_range,
      options,
      activity_users_date,
    } = this.state;
    return (
      <div className="card graph-card">
        <div className="card-body">
          <div className="row">
            <div className="col-sm-12 col-xl-9">
              <div className="row">
                <div className="col-6">
                  <div className="card-title mb-0">Activity Users</div>
                  <div className="small text-muted">
                    <div className="graph-export-action">
                      <small
                        className="text-muted"
                        onClick={() => this.handleExport(1)}
                      >
                        export
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 h-right v-center">
                  <DatePicker
                    className="form-control graph-date-picker"
                    selected={activity_users_date}
                    onChange={(date) =>
                      this.handleChangeDate("activity_users", date)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-xl-3">
              <ButtonToolbar
                className="float-right"
                aria-label="Toolbar with button groups"
              >
                <ButtonGroup className="mr-3" aria-label="First group">
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(1, 1)}
                    active={activity_users_range === 1}
                  >
                    Day
                  </Button>
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(1, 2)}
                    active={activity_users_range === 2}
                  >
                    Month
                  </Button>
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(1, 3)}
                    active={activity_users_range === 3}
                  >
                    Year
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            </div>
          </div>
          <div className="chart-wrapper">
            {active_new_graph ? (
              <Bar data={active_new_graph} options={options} height={120} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderActiveUsers() {
    const { all_counts, active_counts } = this.state;
    const active_rates =
      all_counts === 0 ? 0 : parseInt((active_counts / all_counts) * 100);
    return (
      <div className="card">
        <div className="card-header">
          Active User Rate
          <div className="card-header-actions">
            <div className="graph-export-action">
              <small
                className="text-muted"
                onClick={() => this.handleExport(2)}
              >
                export
              </small>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="chart-wrapper">
            <CircularProgressbar
              className="active-circle-chart"
              value={active_rates}
              text={active_rates + "%"}
              styles={buildStyles({
                textColor: "black",
                pathColor: "#ef6f6c",
                trailColor: "#f9f8f6",
              })}
            />
          </div>
        </div>
      </div>
    );
  }

  renderAppDownloads() {
    return (
      <div className="card">
        <div className="card-header">
          App Downloads
          <div className="card-header-actions">
            <a href="http://www.chartjs.org" className="card-header-action">
              <small className="text-muted">export</small>
            </a>
          </div>
        </div>
        <div className="card-body">
          <div className="chart-wrapper">
            <Line data={line} options={noLabelOptions} />
          </div>
        </div>
      </div>
    );
  }

  renderAppShares() {
    return (
      <div className="card">
        <div className="card-header">
          App Shares
          <div className="card-header-actions">
            <a href="http://www.chartjs.org" className="card-header-action">
              <small className="text-muted">export</small>
            </a>
          </div>
        </div>
        <div className="card-body">
          <div className="chart-wrapper">
            <Line data={line} options={noLabelOptions} />
          </div>
        </div>
      </div>
    );
  }

  renderRevenue() {
    const { revenue_range, revenue_date, revenues_graph } = this.state;
    return (
      <div className="card graph-card">
        <div className="card-body">
          <div className="row">
            <div className="col-sm-12 col-xl-9">
              <div className="row">
                <div className="col-6">
                  <div className="card-title mb-0">Revenue</div>
                  <div className="small text-muted">
                    <div className="graph-export-action">
                      <small
                        className="text-muted"
                        onClick={() => this.handleExport(3)}
                      >
                        export
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 h-right v-center">
                  <DatePicker
                    className="form-control graph-date-picker"
                    selected={revenue_date}
                    onChange={(date) => this.handleChangeDate("revenue", date)}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-xl-3">
              <ButtonToolbar
                className="float-right"
                aria-label="Toolbar with button groups"
              >
                <ButtonGroup className="mr-3" aria-label="First group">
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(4, 1)}
                    active={revenue_range === 1}
                  >
                    Day
                  </Button>
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(4, 2)}
                    active={revenue_range === 2}
                  >
                    Month
                  </Button>
                  <Button
                    color="outline-secondary"
                    onClick={() => this.onHandleRange(4, 3)}
                    active={revenue_range === 3}
                  >
                    Year
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            </div>
          </div>
          <div className="chart-wrapper">
            {revenues_graph ? (
              <Line data={revenues_graph} options={noLabelOptions} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderNumericReport() {
    const { numeric_report_date, dau, mau, stickiness, ds_per_users } =
      this.state;
    return (
      <div className="card">
        <div className="card-header">
          <div className="row">
            <div className="col-7">
              <div className="card-title mb-0">Numeric Report</div>
              <div className="small text-muted">
                <div className="graph-export-action">
                  <small
                    className="text-muted"
                    onClick={() => this.handleExport(4)}
                  >
                    export
                  </small>
                </div>
              </div>
            </div>
            <div className="col-5 h-right v-center">
              <DatePicker
                className="form-control graph-date-picker"
                selected={numeric_report_date}
                onChange={(date) =>
                  this.handleChangeDate("numeric_report_date", date)
                }
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          <Table className="table-reports" responsive striped hover>
            <thead>
              <tr>
                <th>Description</th>
                <th>Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="numeric-report-detail">
                  {"Daily Active Users"}
                </td>
                <td>{dau}</td>
              </tr>
              <tr>
                <td className="numeric-report-detail">
                  {"Monthly Active Users "}
                </td>
                <td>{mau}</td>
              </tr>
              <tr>
                <td className="numeric-report-detail">
                  {"Daily Sessions per DAU "}
                </td>
                <td>{ds_per_users}</td>
              </tr>
              <tr>
                <td className="numeric-report-detail">{"Stickiness"}</td>
                <td>{stickiness}</td>
              </tr>
              {/* <tr>
                                <td className="numeric-report-detail">{"Cost Per Acquisition"}</td>
                                <td>{"20"}</td>
                            </tr> */}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-12 col-sm-8 col-md-8">
            {this.renderActivityUsers()}
          </div>
          <div className="col-12 col-sm-4 col-md-4">
            {this.renderActiveUsers()}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6">
            {this.renderAppDownloads()}
          </div>
          <div className="col-12 col-sm-6 col-md-6">
            {this.renderAppShares()}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6">{this.renderRevenue()}</div>
          <div className="col-12 col-sm-6 col-md-6">
            {this.renderNumericReport()}
          </div>
        </div>
      </div>
    );
  }
}

Report.propTypes = {
  getReportData: PropTypes.func,
  getActivityUsers: PropTypes.func,
  getRevenueGraph: PropTypes.func,
  getNumericReport: PropTypes.func,
};

export default connect(selectors, {
  ...actions.dashboard,
})(withRouter(Report));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Report/index.js